import { withRouter, Redirect } from 'react-router-dom';
import { compact } from 'lodash-es';

const removeSlashes = Component =>
  withRouter(({ location, ...rest }) => {
    const { pathname } = location;
    const cleanPathName = `/${compact(location.pathname.split('/')).join('/')}`;

    if (cleanPathName !== pathname) {
      return <Redirect to={cleanPathName} />;
    }

    return <Component location={location} {...rest} />;
  });

export default removeSlashes;
